import { QueryResult } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import { OrganisationAvatar } from "components/layout/avatar/OrganisationAvatar";
import { GetOrganisationsByNameQuery } from "components/layout/home/SearchEventAndOrganisation.gql.types";
import { EventCard } from "components/routes/root/eventCard/EventCard";
import { EventCardMainSection } from "components/routes/root/eventCard/EventCardMainSection";

type SearchOrganisation = NonNullable<
    NonNullable<
        QueryResult<GetOrganisationsByNameQuery>["data"]
    >["organisationsByName"]
>[number];

export const SearchOrganisationCard: React.FC<{
    organisation: SearchOrganisation;
}> = ({ organisation }) => {
    return (
        <EventCard fullWidth>
            <EventCardMainSection>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <OrganisationAvatar
                        alt={organisation.name}
                        src={organisation.logo}
                        size="lg"
                    />
                    <Typography
                        variant="button"
                        color="text.primary"
                        flexGrow={1}
                    >
                        {organisation.name}
                    </Typography>
                </Stack>
            </EventCardMainSection>
        </EventCard>
    );
};
